import type { AccessProfileId, CommandDeckPreviewBundle } from '../contracts/types'
import { ACCESS_PROFILES, resolveAccessProfile } from '../fixtures/accessProfiles'
import { mapPersonalizationToPreviewBundle } from './mapPersonalizationToPreviewBundle'
import { resolveCommandDeckPersonalizationState } from './resolveCommandDeckPersonalizationState'

export function getCommandDeckPreviewBundle(
  profileParam?: string | null
): CommandDeckPreviewBundle {
  const accessProfileId = resolveAccessProfile(profileParam)
  const access = ACCESS_PROFILES[accessProfileId === 'revoked' ? 'visitor' : accessProfileId]

  const missionHint =
    accessProfileId === 'creator_beta' && access.lastActiveProjectId
      ? { missionId: access.lastActiveProjectId }
      : accessProfileId === 'creator_beta'
        ? { missionId: null }
        : undefined

  const personalization = resolveCommandDeckPersonalizationState({
    mode: 'preview',
    access: {
      ...access,
      displayName: access.displayName ?? 'Creator (preview)',
    },
    accessProfileId,
    missionHint,
  })

  return mapPersonalizationToPreviewBundle(personalization)
}

export function listAccessProfileIds(): AccessProfileId[] {
  return ['visitor', 'creator_beta', 'revoked']
}
